import {IAprovacaoOrcamento, statusAprovacaoColor} from "@models/solicitacoes/orcamento.ts";
import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography} from "@mui/material";
import {ToDateDefault, ToDateString} from "@shared/MathHelp.ts";
import React from "react";

interface AprovacaoInformacaoProps {
    aprovacao: IAprovacaoOrcamento;
    type: 'accordion';
}

export const AprovacaoOrcamentoInformacao: React.FC<AprovacaoInformacaoProps> = ({aprovacao}) => {
    const {aprovador, dataSolicitacao, status, dataAprovacao, motivo} = aprovacao;

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Typography variant={'body2'} color={'text.secondary'}>
                    ID:{aprovacao.id} {ToDateDefault(dataSolicitacao)} - <Typography component={'span'}
                                                                                     color={statusAprovacaoColor(status)}>{status}</Typography>
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <Typography variant={'body2'}>
                            Data e hora: {ToDateString(dataAprovacao, 'DD/MM/YYYY HH:mm')}
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <Typography variant={'body2'}>
                            Motivo: {motivo}
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <Typography variant={'body2'}>
                            Atualizado por: {aprovador?.nome}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>

    );
};